import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

export const PaymentSuccess = () => {
  const location = useLocation();
  const { paymentId, products } = location.state || {};

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-sm p-8 text-center">
        <div className="flex justify-center mb-4">
          <CheckCircle className="w-16 h-16 text-green-500" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Payment Successful!
        </h1>
        
        <p className="text-gray-600 mb-6">
          Thank you for your purchase. Your payment has been processed successfully.
        </p>

        {paymentId && (
          <p className="text-sm text-gray-500 mb-4">
            Payment ID: {paymentId}
          </p>
        )}

        {products && products.length > 0 && (
          <div className="border-t border-gray-200 pt-4 mt-4">
            <h2 className="text-lg font-semibold mb-2">Order Summary</h2>
            {products.map((product: any) => (
              <div key={product.id} className="flex justify-between text-sm">
                <span>{product.name}</span>
                <span>₹{product.price.toFixed(2)}</span>
              </div>
            ))}
          </div>
        )}

        <Link
          to="/"
          className="btn mt-6 inline-block"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};